import React from "react";
import { UserBox } from "../../containers/user/UserBox";

export const UserPage = () => {
  return (
    <div>
      <UserBox />
    </div>
  );
};
